import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error-page" }
const _hoisted_2 = { class: "error-page-blank-wrap" }
const _hoisted_3 = { class: "site-error" }
const _hoisted_4 = { class: "headline" }
const _hoisted_5 = { class: "error-content" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "error-content-text" }, "海面雾气太大", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", { class: "error-content-text" }, "受天气影响，该页无法正常显示", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: "/error/images/error-bg.png",
  style: {"padding":"20px 0 120px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.code), 1),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("h5", null, [
            _createTextVNode(" 你可以 "),
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
            }, "返回上一页"),
            _createTextVNode(" 。")
          ])
        ]),
        _hoisted_8
      ])
    ])
  ]))
}